import axios from 'axios';

function removeInvalidQueryParams(baseUrl, relativeUrl) {
  const urlObj = new URL(relativeUrl, baseUrl);
  const queryParams = new URLSearchParams(urlObj.search);

  for (const [key, value] of queryParams.entries()) {
    if (value === '' || value === 'undefined') {
      queryParams.delete(key);
    }
  }

  urlObj.search = queryParams.toString();
  return urlObj.toString();
}

const appendCommonQuery = (url,baseUrl) => {

  const hotel = localStorage.getItem('hotel');
  const reservationId = localStorage.getItem('reservation_id');
  const user_id = localStorage.getItem('user_id');

  if (hotel || reservationId || user_id) {
    url += url.includes('?') ? '&' : '?';

    if (hotel) {
      url += `hotel=${hotel}`;
    }

    if (reservationId) {
      if (hotel) {
        url += '&';
      }
      url += `reservation_id=${reservationId}`;
    }

    if (user_id) {
      if (hotel || reservationId) {
        url += '&';
      }
      url += `user_id=${user_id}`;
    }
  }

  // const baseUrl = localStorage.getItem('server') === 'prod' 
  //   ? process.env.REACT_APP_PROD_URL 
  //   : process.env.REACT_APP_DEV_URL;

  return removeInvalidQueryParams(baseUrl, url);
};

const Axios = axios.create({
  baseURL: localStorage.getItem('server') === 'prod'
    ? process.env.REACT_APP_PROD_URL
    : process.env.REACT_APP_DEV_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

Axios.interceptors.request.use(
  (config) => {
    config.baseURL = localStorage.getItem('server') === 'prod'
      ? process.env.REACT_APP_PROD_URL
      : process.env.REACT_APP_DEV_URL;

    config.url = appendCommonQuery(config.url,config.baseURL);

    const apiKey = localStorage.getItem('key');
    if (apiKey) {
      config.headers.Authorization = `Api-Key ${apiKey}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default Axios;
